import { Steps } from 'antd';
import dayjs from 'dayjs';
import type { FC } from 'react';
import styles from './index.less';

const { Step } = Steps;

export type StepperProps = {
  activeStep?: number;
  steps: {
    done: boolean;
    stateName: string;
    stateTime: number;
    stateCode: string;
  }[];
  className?: string;
};

const InnerStepper: FC<StepperProps> = ({ steps, className }) => {
  return (
    <div className={styles.warp}>
      <Steps size="small" labelPlacement="vertical" className={`${className}`}>
        {steps?.map(({ done, stateCode, stateName, stateTime }) => {
          return (
            <Step
              title={stateName}
              status={done ? 'finish' : 'wait'}
              description={
                stateTime ? dayjs(stateTime).format('YYYY-MM-DD') : ''
              }
              key={stateCode}
            />
          );
        })}
      </Steps>
    </div>
  );
};

export default InnerStepper;
